import Cookies from 'js-cookie';
import apiSlice from './apiSlice';

const apiPasswordSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    requestPasswordReset: builder.mutation({
      query: ({ email }) => ({
        url: 'dj-rest-auth/password/reset/',
        method: 'POST',
        body: { email },
        headers: {
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
    }),
    changeForgottenPassword: builder.mutation({
      // eslint-disable-next-line camelcase
      query: ({ new_password1, new_password2, uid, token }) => ({
        url: 'dj-rest-auth/password/reset/confirm/',
        method: 'POST',
        body: { new_password1, new_password2, uid, token }, // eslint-disable-line camelcase
        headers: {
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
    }),
    changePassword: builder.mutation({
      // eslint-disable-next-line camelcase
      query: ({ new_password1, new_password2 }) => ({
        url: 'dj-rest-auth/password/change/',
        method: 'POST',
        body: { new_password1, new_password2 }, // eslint-disable-line camelcase
        headers: {
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
    }),
  }),
});

export const { useRequestPasswordResetMutation, useChangeForgottenPasswordMutation, useChangePasswordMutation } = apiPasswordSlice;

export default apiPasswordSlice;
